import React from 'react'

import { Route, Routes } from "react-router-dom"

import ConsolidationCreateScreen from "screens/App/CRM/Consolidation/ConsolidationCreateScreen"
import ConsolidationDetailScreen from "screens/App/CRM/Consolidation/ConsolidationDetailScreen"
import ConsolidationEditScreen from "screens/App/CRM/Consolidation/ConsolidationEditScreen"
import ConsolidationListScreen from "screens/App/CRM/Consolidation/ConsolidationListScreen"

import NotFoundScreen from "screens/NotFoundScreen"

const ConsolidationRouter = () => {
    return (
        <Routes>
            <Route path="create" element={<ConsolidationCreateScreen />} />

            <Route path="list" element={<ConsolidationListScreen />} />

            <Route path=":id/detail" element={<ConsolidationDetailScreen />} />

            <Route path=":id/edit" element={<ConsolidationEditScreen />} />

            <Route path="*" element={<NotFoundScreen />} />

        </Routes>
    )
}

export default ConsolidationRouter